const $ = window.$
import {trackEventSP} from 'js/studios/shared/tracking'

window.$(document).ready(function(){
  //FAQ Open and close
  $('.question_expand').on('click', function(e){
    e.preventDefault()
    if(!$(this).parents('.question_container').hasClass('is_open')){
      trackEventSP('click_expand_faq_question', 'browse', {
        'label': $(this).attr('title')
      })
    }
    $(this).parents('.question_container').toggleClass('is_open')
  })
})
